/**
 * Adds a dom event when a swatch parent group is selected.
 */
export class SwatchColorParentSelectBehaviour {
  constructor(parent) {
    this.parent = parent;
  }

  activateSwatchGroup($swatchGroup) {
    const name = $swatchGroup.attr('data-name');
    this.parent.dom.trigger('swatch-gallery-select', name);
  }
}